export { default, defaultContext } from "./tabs-context";
